import { createRouter, createWebHistory } from "vue-router";

import { useQuestionnaire, useToast } from "@/composables";

export const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  strict: true,
  routes: [
    {
      path: "/",
      redirect: { name: "start" }
    },
    {
      name: "start",
      path: "/start",
      component: () => import("@/pages/Start.vue")
    },
    {
      name: "login",
      path: "/login",
      component: () => import("@/pages/Login.vue")
    },
    {
      name: "questionnaire",
      path: "/questionnaire",
      component: () => import("@/pages/Questionnaire.vue")
    },
    {
      name: "order",
      path: "/order",
      component: () => import("@/pages/Order.vue")
    },
    {
      name: "order-confirmation",
      path: "/order/confirmation",
      component: () => import("@/pages/OrderConfirmation.vue")
    },
    {
      name: "result",
      path: "/result",
      component: () => import("@/pages/Result.vue"),
      beforeEnter: () => {
        const { validateResponse } = useQuestionnaire();
        const { showError } = useToast();

        if (!validateResponse()) {
          showError("Spørgeskema skal udfyldes før du kan se dine resultater");

          return { name: "start" };
        }
      }
    },
    {
      name: "reset",
      path: "/reset",
      redirect: () => {
        const { showWarning } = useToast();

        sessionStorage.clear();
        showWarning("Nulstilling gennemført");

        return { name: "start" };
      }
    },
    {
      path: "/:notFound(.*)",
      redirect: "/"
    }
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }

    return { top: 0, behavior: "instant" };
  }
});
